import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__arquivos_endpoints} from "@components/shared/arquivos/endpoints/__arquivos_endpoints.ts";

export function useArquivo() {
    const {GetFile} = useApi()

    const getArquivo = ({id}: {
        id: string | number
    }) => {
        if (typeof id == 'string') {
            return GetFile(__arquivos_endpoints.v2["get-by-guid"]({data: {guid: id}}))
        }
        return GetFile(__arquivos_endpoints.v2["get-by-id"]({data: {idArquivo: id}}))
    }

    return {getArquivo: getArquivo}
}